import { render, staticRenderFns } from "./CardFeed.vue?vue&type=template&id=73d1a792&scoped=true"
import script from "./CardFeed.vue?vue&type=script&lang=js"
export * from "./CardFeed.vue?vue&type=script&lang=js"
import style0 from "./CardFeed.vue?vue&type=style&index=0&id=73d1a792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d1a792",
  null
  
)

export default component.exports